import PropTypes from 'prop-types'; // TODO: need to implement yellow and transparent across other components

var colors = ['teal', 'red', 'evergreen', 'white', 'gold', 'grey', 'green', 'blueLight', 'orange'];
export default PropTypes.oneOf(colors);